import React from "react";
import { App, InputNumber, Typography } from "antd";

const { Text } = Typography;

export default function QuantityStep({ quantity, maxStock, onChange }) {
  const { message } = App.useApp();

  return (
    <div>
      <Text>¿Cuántas unidades deseas canjear?</Text>
      <br />
      <InputNumber
        min={1}
        max={maxStock}
        value={quantity}
        size="large"
        style={{ width: "100%", marginTop: 8 }}
        onChange={(value) => {
          if (value > maxStock) {
            message.warning(`Solo hay ${maxStock} unidades disponibles`);
          }
          onChange(Math.min(Math.max(1, value || 1), maxStock));
        }}
      />
    </div>
  );
}
